import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import PageTitle from "../../components/PageTitle";
import CardWrapper from "../../layouts/CardWrapper";
import ImagePreviewLightbox from "../../components/ImagePreviewLightbox";
import { CheckCircleIcon, EyeIcon } from "../../components/SVGIcon";
import { getConversationDetail } from "../../services/chatServices";
import { useAlert } from "../../contexts/AlertContext";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { useAtom } from "jotai";
import { authAtom } from "../../states/auth";
import { useDebounce } from "../../hooks/useDebounce"; // adjust path as needed
import { getTemplates } from "../../services/templateService";
import { CardFooter, Modal } from "react-bootstrap";
import ReportPreview from "./../ReportPreview/ReportPreview";
import TablePagination from "../../components/TablePagination/TablePagination";
import { useNavigate } from "react-router-dom";

const formatDateTimeToString = (dateObjTmp) => {
  const dateObj = new Date(dateObjTmp);
  if (dateObj) {
    const formattedDate = dateObj.toLocaleDateString('en-GB'); // Gives "dd/mm/yyyy"
    const formattedTime = dateObj.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // ensures AM/PM format
    });
    const formattedDateWithDashes = formattedDate?.replace(/\//g, '-'); // converts dd/mm/yyyy to dd-mm-yyyy
    return `${formattedDateWithDashes}, ${formattedTime}`;
  }
}

const formatDate = (date) => {
  if (!date) return "From - To Date";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
};

const getAddress = (userInfo) => {
  const addressArr = [];
  if (userInfo?.address) {
    addressArr.push(userInfo?.address);
  }
  if (userInfo?.city) {
    addressArr.push(userInfo?.city);
  }
  if (userInfo?.state?.name) {
    addressArr.push(userInfo?.state?.name);
  }
  if (userInfo?.country?.code) {
    addressArr.push(userInfo?.country?.code);
  }
  if (userInfo?.zipCode) {
    addressArr.push(userInfo?.zipCode);
  }
  return addressArr.join(", ");
};

const getPhone = (userInfo) => {
  let phoneNo = userInfo?.phoneNo || "";
  const countryCode = userInfo?.countryCode || "";
  console.log("asdasd", phoneNo)
  if (phoneNo.startsWith("0")) {
    phoneNo = phoneNo.slice(1);
  }

  const phoneString = `+${countryCode}${phoneNo}`;
  const parsed = parsePhoneNumberFromString(phoneString);

  if (!parsed) return "";

  // 📞 Example output: +91 91234 56789 or +1 (201) 555-0123
  return `+${parsed.countryCallingCode} ${parsed.formatNational().startsWith("0") ? parsed.formatNational().slice(1) : parsed.formatNational()}`;
};


function getDateTimeFormattedString(totalSeconds) {
  const days = Math.floor(totalSeconds / (24 * 3600));
  const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = String(Math.ceil(totalSeconds % 60)).padStart(2, '0');;

  const parts = [];

  if (days > 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`);
  if (hours > 0) parts.push(`${hours} hr${hours !== 1 ? 's' : ''}`);
  if (minutes > 0) parts.push(`${minutes} min${minutes !== 1 ? 's' : ''}`);
  parts.push(`${seconds} sec${seconds !== 1 ? 's' : ''}`);

  return parts.join(', ');
}

function getDurationBetween(startTime, endTime) {

  console.log("checkdate1",startTime)
  console.log("checkdate2",endTime)

  const start = new Date(startTime);
  const end = new Date(endTime);

  const diffMs = Math.abs(end - start); // Always positive
  const totalSeconds = Math.floor(diffMs / 1000) || 0;

  const days = Math.floor(totalSeconds / (24 * 3600));
  const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    totalSeconds: totalSeconds,
    formatted: getDateTimeFormattedString(totalSeconds)
  };
}

const getTotalConversationDuration = (calls = []) => {
  const allCallHistories = [];

  // Step 1: Flatten all callHistories from each call
  for (const call of calls) {
    if (Array.isArray(call.callHistories)) {
      for (const history of call.callHistories) {
        if (history.start_time && history.end_time) {
          const start = new Date(history.start_time).getTime();
          const end = new Date(history.end_time).getTime();

          allCallHistories.push({ start_time: start, end_time: end });
        }
      }
    }
  }

  // Step 2: Sort by start_time
  allCallHistories.sort((a, b) => a.start_time - b.start_time);

  // Step 3: Merge overlapping intervals
  const merged = [];
  for (const interval of allCallHistories) {
    if (
      !merged.length ||
      merged[merged.length - 1].end_time < interval.start_time
    ) {
      merged.push({ ...interval });
    } else {
      merged[merged.length - 1].end_time = Math.max(
        merged[merged.length - 1].end_time,
        interval.end_time
      );
    }
  }

  // Step 4: Calculate total duration
  let totalSeconds = 0;
  for (const { start_time, end_time } of merged) {
    const duration = (end_time - start_time) / 1000;
    totalSeconds += Math.max(0, duration);
  }

  // Step 5: Format duration
  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins} min${mins !== 1 ? "s" : ""} ${secs} sec${secs !== 1 ? "s" : ""}`;
  };

  return { "totalSeconds": totalSeconds, "formatted": formatDuration(totalSeconds) };
}

const TemplateSelect = () => {


  let { conversationId, templateType } = useParams();

  console.log("conversationId", conversationId)

  const [conversationData, setConversationData] = useState({});
  const [anotherMember, setAnotherMember] = useState({});
  const [myMember, setMyMember] = useState({});
  const [callDurations, setCallDurations] = useState({});
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalSessionDuration, setTotalSessionDuration] = useState({});
  const [auth] = useAtom(authAtom);
  const [loading, setLoading] = useState(false);
  const [templatesShow, setTemplatesShow] = useState([]);
  const { showAlert } = useAlert();
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [templateToPreview, setTemplateToPreview] = useState(null);
  const [totalTemplatesCount, setTotalTemplatesCount] = useState(0);
  const [totalChatDuration, setTotalChatDuration] = useState({});
  const navigate = useNavigate();
  const [filter, setFilter] = useState({
    no_of_result: 12,
    page: 1,
    search: null,
    templateType: templateType,
  });

  const debouncedFilter = useDebounce(filter, 500);
  const changeFilterCriteria = (e) => {
    if (e.target.name == "search") {
      filter.page = 1;
      setSelectedPage(1);
    }
    console.log(e.target.name, e.target.value);
    filter[e.target.name] = e.target.value;
    setFilter({ ...filter });
    console.log("filter", filter);
  };

  useEffect(() => {

    if (!['field', 'digital'].includes(templateType)) {
      navigate("/report-hub/create")
    }
  }, [templateType])

  const changeFilterCriteriaByName = (name, value) => {
    console.log(name, value);
    filter[name] = value;
    setFilter({ ...filter });
    console.log("filter", filter);
  };

  useEffect(() => {
    changeFilterCriteriaByName("page", selectedPage);
  }, [selectedPage]);

  const changeTemplateFilterCriteriaByName = (name, value) => {
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getConversationDetailData = async () => {
    try {
      const data = await getConversationDetail(conversationId);
      setConversationData(data?.data)
      const anotherMemberData = data?.data?.conversationMembers?.find((e) => e.user_id != auth?.user?.id);
      const myMemberData = data?.data?.conversationMembers?.find((e) => e.user_id != data?.data?.createdBy?.id);
      setAnotherMember(anotherMemberData);
      setMyMember(myMemberData);
      console.log("myMemberData", myMemberData)
      setTotalSessionDuration(() => getDurationBetween(data?.data?.endTime, data?.data?.startTime || data?.data?.createdAt));
      setTotalChatDuration(() =>
        getDurationBetween(data?.data?.firstMsgTimestamp ?? data?.data?.startTime, data?.data?.endTime),
      );
      setCallDurations(getTotalConversationDuration(data?.data?.calls || []));


    } catch (error) {
      console.error("Error fetching chat conversation:", error);
      showAlert({
        title: "Chat Screen Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  useEffect(() => {
    // alert(conversationId)
    if (conversationId != null) {
      getConversationDetailData();
    }

  }, [conversationId])

  const getAllTemplates = async () => {
    setLoading(true);
    try {
      const query = { ...debouncedFilter };
      // remove templateType if "all"
      if (query.templateType === "all") {
        delete query.templateType;
      }
      const data = await getTemplates(query);

      const tempplateFiles = data?.data || [];
      setTotalTemplatesCount(data?.totalResult);
      const createdFiles = tempplateFiles.map((element) => {
        let badge = null;
        if (element.templateType === "field") {
          badge = { text: "Field", className: "badge-success" };
        } else {
          badge = { text: "Digital", className: "badge-primary" };
        }
        return {
          ...element,
          img: "/images/file-type-icon-pdf.svg",
          badge,
          author:
            element.createdBy.firstName + " " + element.createdBy.lastName,
        };
      });

      setTemplatesShow(createdFiles || []); // adjust based on API response shape
    } catch (err) {
      console.error("Error fetching templates:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllTemplates();
  }, [debouncedFilter]); // re-fetch when filters change

  // const allTemplates = [
  //   {
  //     id: 1,
  //     name: "Monthly Field Report",
  //     badge: { text: "Field", className: "badge-success" },
  //     fileId: "file1",
  //     state: "share",
  //     img: "/images/file-type-icon-pdf.svg",
  //     created: "04-24-2025",
  //     author: "Emma Smith",
  //   },
  //   {
  //     id: 2,
  //     name: "Digital Service Summary Report for All Remote Service Calls",
  //     badge: { text: "Digital", className: "badge-primary" },
  //     fileId: "file2",
  //     state: "share",
  //     img: "/images/file-type-icon-pdf.svg",
  //     created: "04-24-2025",
  //     author: "Emma Smith",
  //   },
  //   {
  //     id: 3,
  //     name: "Field Inspection Checklist for Safety and Compliance Review",
  //     badge: { text: "Field", className: "badge-success" },
  //     fileId: "file3",
  //     state: "transfer",
  //     img: "/images/file-type-icon-pdf.svg",
  //     created: "04-24-2025",
  //     author: "Emma Smith",
  //   },
  //   {
  //     id: 4,
  //     name: "Digital Audit Log for System Access and Change Management",
  //     badge: { text: "Digital", className: "badge-primary" },
  //     fileId: "file4",
  //     img: "/images/file-type-icon-pdf.svg",
  //     created: "04-24-2025",
  //     author: "Emma Smith",
  //   },
  // ];

  return (
    <>
      <Row className="align-items-end justify-content-between mb-4">
        <Col lg="7">
          <PageTitle title="Select Template" />
        </Col>
        <Col lg="5" className="text-end">
          <Button
            variant="white"
            className="btn-md border-0 d-inline-flex align-items-center gap-2"
            onClick={() => { navigate(-1) }}
          >
            {/* <Image
              src="/images/arrow-left.svg"
              width={18}
              height={18}
              alt="Back Arrow"
            /> */}
            Cancel
          </Button>
        </Col>
      </Row>
      <Row>
        {(Object.keys(conversationData).length > 0) && <Col lg="4">
          <CardWrapper className="full-box-05 p-0">
            <div className="p-3">
              <h2 className="fs-20 fw-semibold text-gray-700 mb-4">
                Session Information
              </h2>
              <div className="d-flex align-items-center gap-3">
                {anotherMember?.user?.profilePic ? (
                  <ImagePreviewLightbox className="user-avtar user-avtar-48" src={anotherMember?.user?.profilePic}>
                    <Image
                      width="48"
                      height="48"
                      alt="User Avatar"
                      className="object-fit-cover rounded-circle"
                      src={anotherMember?.user?.profilePic}
                    />
                  </ImagePreviewLightbox>
                ) : (
                  <div className="user-avtar user-avtar-48 bg-blue-600">{anotherMember?.user?.firstName?.charAt(0)}</div>
                )}
                <div>
                  <h3 className="fs-20 fw-semibold mb-0">{anotherMember?.user?.firstName || ''} {anotherMember?.user?.lastName || ''}</h3>
                  <ul className="d-flex flex-wrap align-items-center gap-2 list-unstyled mb-0">
                    <li className="fs-14">{anotherMember?.user?.email || ''}</li>
                    <li className="dot-separator md"></li>
                    <li className="fs-14">{getPhone(anotherMember?.user)}</li>
                    {/* <li className="fs-14">+ {anotherMember?.user?.countryCode || ''} {anotherMember?.user?.phoneNo || ''}</li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div className="border-top border-gray-200 p-3">
              <h4 className="text-blue fs-7 fw-medium mb-4">Company Details</h4>

              <div className="mb-3">
                <span className="fs-14 text-gray-500 d-block mb-2">
                  Company Name
                </span>
                <div className="d-flex align-items-center gap-2">
                  <Image
                    width="32"
                    height="32"
                    alt="User Circle Gear Icon"
                    src="/images/user-circle-gear-blue.svg"
                  />
                  {anotherMember?.user?.companyName || ''}
                </div>
              </div>

              <div className="mb-3">
                <span className="fs-14 text-gray-500 d-block mb-2">
                  Company Address
                </span>
                <p className="mb-0">
                  {getAddress(anotherMember?.user)}
                </p>
              </div>
            </div>
            <div className="border-top border-gray-200 p-3">
              <h4 className="text-blue fs-7 fw-medium mb-4">
                Receiver Details
              </h4>

              <div className="mb-3">
                <span className="fs-14 text-gray-500 d-block mb-2">
                  Receiver
                </span>
                <div className="d-flex align-items-center gap-2">
                  {myMember?.user?.profilePic ? (
                    <ImagePreviewLightbox
                      className="user-avtar user-avtar-32"
                      src={myMember?.user?.profilePic}
                    >
                      <Image
                        width="32"
                        height="32"
                        alt="User Avatar"
                        className="object-fit-cover rounded-circle"
                        src={myMember?.user?.profilePic}
                      />
                    </ImagePreviewLightbox>
                  ) : (
                    <Image
                      width={32}
                      height={32}
                      alt="User Avatar"
                      className="object-fit-cover rounded-circle"
                      src={`https://ui-avatars.com/api/?name=${myMember?.user?.firstName}+${myMember?.user?.lastName}&background=007bff&color=fff&size=100`}
                    />
                  )}
                  {myMember?.user?.firstName || ''} {myMember?.user?.lastName || ''}
                </div>
              </div>
              {conversationData?.expertise != null && <div className="mb-3">
                <span className="fs-14 text-gray-500 d-block mb-2">
                  Expertise
                </span>
                <p className="mb-0">{conversationData?.expertise?.name}</p>
              </div>}
            </div>
            <div className="border-top border-gray-200 p-3">
              <h4 className="text-blue fs-7 fw-medium mb-4">Session Details</h4>

              <div className="mb-3">
                <span className="fs-14 text-gray-500 d-block mb-2">
                  Session Type
                </span>
                {conversationData?.conversationType?.includes("chat") ? <div className="session-type-badge d-inline-flex align-items-center gap-2">
                  <Image
                    src="/images/chats-circle.svg"
                    width={20}
                    height={20}
                    alt="Chat Circle Icon"
                  />{" "}
                  Chat
                </div> : <div className="session-type-badge d-inline-flex align-items-center gap-2">
                  <Image
                    src="/images/video-camera-blue.svg"
                    width={20}
                    height={20}
                    alt="Video Camera Blue Icon"
                  />{" "}
                  Video
                </div>}
              </div>

              <div className="mb-3">
                <span className="fs-14 text-gray-500 d-block mb-2">
                  {conversationData?.conversationType?.includes("chat") ? "Session Time" : "Session Timeline"}
                </span>
                <p className="mb-0">{formatDateTimeToString(conversationData?.startTime || conversationData?.createdAt)}{conversationData?.endTime && (" - " + formatDateTimeToString(conversationData?.endTime))}</p>
              </div>

              {totalSessionDuration.totalSeconds > 0 && <div className="mb-3">
                <span className="fs-14 text-gray-500 d-block mb-2">
                  Total Session Duration
                </span>
                <p className="mb-0">{totalSessionDuration.formatted}</p>
              </div>}
              {callDurations?.totalSeconds > 0 && <div className="mb-3">
                <span className="fs-14 text-gray-500 d-block mb-2">
                  Video Session Total Duration
                </span>
                <p className="mb-0">{callDurations?.formatted}</p>
              </div>}
              <div className="mb-3">
                <span className="fs-14 text-gray-500 d-block mb-2">
                  Chat Session Total Duration
                </span>
                {totalChatDuration.totalSeconds > 0 &&
                  <p className="mb-0">{totalChatDuration.formatted}</p>
                }
              </div>
            </div>
          </CardWrapper>
        </Col>}
        <Col lg={(Object.keys(conversationData).length > 0) ? "8" : "12"}>
          <CardWrapper>
            <Row className="gy-2 gy-sm-0 align-items-center mb-4">
              <Col>
                <h2 className="fs-20 fw-semibold text-gray-700 mb-0">
                  {templateType === "digital" && "Create Session Report"}
                  {templateType === "field" && "Create Field Report"}
                </h2>
              </Col>
              <Col xl="4" lg="5" md="7" sm="8">
                <input
                  onChange={changeFilterCriteria}
                  name="search"
                  className="form-control form-control-search"
                  aria-label="Search Input"
                  placeholder="Search here..."
                  autocomplete="off"
                  type="text"
                />
              </Col>
            </Row>

            <div className="container overflow-y-auto" style={{ height: 'calc(100vh - 268px)' }}>
              <Row className="g-3">
                {templatesShow?.map((template) => (
                  <Col lg="4" md="6" key={template.id}>
                    {/* active: class when item is select */}
                    <div className="file-info-box">
                      <div className="file-info-box-body">
                        <Image
                          className="rounded-3 object-fit-cover"
                          src={template?.img}
                          width={64}
                          height={64}
                          alt="PDF File"
                        />
                        <h3 className="text-truncate fs-14 fw-medium text-gray-700 mb-0 mt-3">
                          {template?.name}
                        </h3>
                        <ul className="d-md-flex align-items-md-center gap-2 list-unstyled mt-2 mb-0">
                          <li className="fs-12 fw-medium text-gray-500">
                            Created on {formatDate(new Date(template?.createdAt))}
                          </li>
                          <li className="dot-separator"></li>
                          <li className="fs-12 fw-medium text-gray-500">
                            {template?.author}
                          </li>
                        </ul>
                      </div>
                      <div className="file-info-btns">
                        <Button
                          as="button"
                          variant="transparent"
                          onClick={() => {
                            setTemplateToPreview(template);
                            setShowPreviewModal(true);
                          }}
                          className="fs-14 fw-500 hover-text-blue d-flex align-content-center justify-content-center gap-1 w-100"
                        >
                          <span className="icon-text-wrapper">
                            <EyeIcon />
                            <span className="icon-text-label">Preview</span>
                          </span>
                        </Button>
                        <Button
                          as="button"
                          variant="transparent"
                          onClick={() => {
                            // navigate(template);
                            if(templateType === 'digital'){
                              navigate(
                                "/report-hub/create/" + templateType + "/" + conversationData?.id + "/" + template?.id
                              );
                            }else{
                              navigate(
                                "/report-hub/create/" + templateType + "/" + template?.id
                              )
                            }
                          }}
                          className="fs-14 fw-500 hover-text-green d-flex align-content-center justify-content-center gap-1 w-100"
                        >
                          <span className="icon-text-wrapper">
                            <CheckCircleIcon />
                            <span className="icon-text-label">Select</span>
                          </span>
                        </Button>
                      </div>
                    </div>
                  </Col>
                ))}

              </Row>
            </div>
            <CardFooter>
              <TablePagination
                selectedPage={selectedPage}
                setSelectedPage={setSelectedPage}
                totalResults={totalTemplatesCount}
                resultsPerPage={12}
              />
            </CardFooter>
          </CardWrapper>

        </Col>

      </Row>
      {/* Quick Preview Modal */}
      <Modal
        className="quick-preview-modal preview-modal"
        show={!!showPreviewModal}
        onHide={() => (setTemplateToPreview(null), setShowPreviewModal(false))}
        centered
        size="xl"
      >
        <Modal.Header
          className="d-flex align-items-center justify-content-between gap-4 p-4 border-0"
          closeButton
        >
          <Modal.Title className="fs-20 fw-semibold text-gray-700">
            {templateToPreview?.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <ReportPreview data={templateToPreview} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TemplateSelect;
